import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HelperService } from '../Helper/helper.service';
import { catchError, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  apiURL: string  = environment.apiURL;

  constructor(private http: HttpClient, private helperService: HelperService,@Inject(PLATFORM_ID) private platformId: Object) {}

  // Post API Call
  postAPICall(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }

    if (localStorage.getItem('token')) {
      headers = headers.append('Authorization', localStorage.getItem('token')!);
    }

    return this.http
      .post<any>(this.apiURL + requestData.url, requestData.data, { headers })
      .pipe(catchError(this.helperService.handleError('error ', [])));
  }
  // Post API Call Text
  postAPICallText(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (localStorage.getItem('token')) {
      headers = headers.append('Authorization', localStorage.getItem('token')!);
    }

    return this.http
      .post(this.apiURL + requestData.url, requestData.data, { headers, responseType:'text' });
  }

  // Get API Call
  getAPICall(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }
    if (localStorage.getItem('token')) {
      headers = headers.append('Authorization', localStorage.getItem('token')!);
    }
    let params = new HttpParams();
    for (const key in requestData.data) {
      if (requestData.data.hasOwnProperty(key)) {
        params = params.append(key, requestData.data[key]);
      }
    }
    return this.http
      .get<any>(this.apiURL + requestData.url, { headers, params })
  }

    // Get API Call
    getAPICallPurohit(requestData: any) {
      let headers: HttpHeaders = new HttpHeaders();
      if (requestData.contentType) {
        headers = headers.append('Accept', requestData.contentType);
      } else {
        headers = headers.append('Accept', 'application/json');
      }
      if (localStorage.getItem('purohit-token')) {
        headers = headers.append('Authorization', localStorage.getItem('purohit-token')!);
      }
      let params = new HttpParams();
      for (const key in requestData.data) {
        if (requestData.data.hasOwnProperty(key)) {
          params = params.append(key, requestData.data[key]);
        }
      }
      return this.http
        .get<any>(this.apiURL + requestData.url, { headers, params })
    }

    // Post API Call
  postAPICallPurohit(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }

    if (localStorage.getItem('purohit-token')) {
      headers = headers.append('Authorization', localStorage.getItem('purohit-token')!);
    }

    return this.http
      .post<any>(this.apiURL + requestData.url, requestData.data, { headers })
  }

  // Get API Call for encrypted response
  getAPICallText(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (localStorage.getItem('token')) {
      headers = headers.append('Authorization', localStorage.getItem('token')!);
    }
    let params = new HttpParams();
    for (const key in requestData.data) {
      if (requestData.data.hasOwnProperty(key)) {
        params = params.append(key, requestData.data[key]);
      }
    }
    return this.http
      .get(this.apiURL + requestData.url, { headers, params, responseType: 'text'})
      .pipe(catchError(this.helperService.handleError('error ', [])));
  }

  // Put API Call
  putAPICall(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }
    if (localStorage.getItem('token')) {
      headers = headers.append('Authorization', localStorage.getItem('token')!);
    }
    let params = new HttpParams();
    for (const key in requestData.data) {
      if (requestData.data.hasOwnProperty(key)) {
        params = params.append(key, requestData.data[key]);
      }
    }
    return this.http
      .put<any>(this.apiURL + requestData.url, requestData.data, {
        headers,
        params,
      })
      .pipe(catchError(this.helperService.handleError('error ', [])));
  }

  // Put API Call
  putAPICallText(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (localStorage.getItem('token')) {
      headers = headers.append('Authorization', localStorage.getItem('token')!);
    }
    let params = new HttpParams();
    for (const key in requestData.data) {
      if (requestData.data.hasOwnProperty(key)) {
        params = params.append(key, requestData.data[key]);
      }
    }
    return this.http
      .put(this.apiURL + requestData.url, requestData.data, {
        headers,
        params,
        responseType: 'text'
      })
      .pipe(catchError(this.helperService.handleError('error ', [])));
  }

  // Delete API Call
  deleteAPICall(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }
    if (localStorage.getItem('token')) {
      headers = headers.append('Authorization', localStorage.getItem('token')!);
    }

    return this.http
      .delete<any>(this.apiURL + requestData.url, { headers })
      .pipe(catchError(this.helperService.handleError('error ', [])));
  }

  // Delete API Call
  deleteAPICallText(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (localStorage.getItem('token')) {
      headers = headers.append('Authorization', localStorage.getItem('token')!);
    }

    return this.http
      .delete(this.apiURL + requestData.url, { headers, responseType: 'text' })
      .pipe(catchError(this.helperService.handleError('error ', [])));
  }

    // Post API Call for any files
  postHttpCallImageUtsavPermission(senddata: any) {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('enctype', 'multipart/form-data');
    if (localStorage.getItem('token')) {
      headers = headers.append('Authorization', localStorage.getItem('token')!);
    }

    if (localStorage.getItem('utsav-token')) {
      headers = headers.append('x-access-token', localStorage.getItem('utsav-token')!);
    }

    return this.http
      .post<any>(this.apiURL + senddata.url, senddata.data, { headers });
  }

  postLogDataCommonService(paramsData: any){
    let headers: HttpHeaders = new HttpHeaders();
    let params = new HttpParams();
    for (const key in paramsData.data) {
      if (paramsData.data.hasOwnProperty(key)) {
        params = params.append(key, paramsData.data[key]);
      }
    }
    return this.http
      .get(this.apiURL + paramsData.url, { headers, params })
  }

  isMobileBrowser(): boolean {
    // console.log(window.innerWidth);
    const userAgent = isPlatformBrowser(this.platformId) ? window.navigator.userAgent : '';
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  }


  postAPICallWithHeader(requestData: any) {
    let headers: HttpHeaders = new HttpHeaders();
    if (requestData.contentType) {
      headers = headers.append('Accept', requestData.contentType);
    } else {
      headers = headers.append('Accept', 'application/json');
    }

    if (localStorage.getItem('token')) {
      headers = headers.append('Authorization', localStorage.getItem('token')!);
    }

    return this.http
      .post<any>(this.apiURL + requestData.url, requestData.data, { headers })
  }
}
